export const windDirection = [
  {
    label: "North",
    value: "north",
  },
  {
    label: "South",
    value: "south",
  },
  {
    label: "East",
    value: "east",
  },
  {
    label: "West",
    value: "west",
  },
];
